// extracted by mini-css-extract-plugin
module.exports = {"titleBar":"CustomDialogTitleBar_titleBar__1bIif","title":"CustomDialogTitleBar_title__27ve7","actions":"CustomDialogTitleBar_actions__oz4hG"};